
import React, { useContext } from 'react';
import { AppContext } from '../App.tsx';
import { AppStep } from '../types.ts';
import { Play, Copy, Check } from 'lucide-react';

const CodeViewPage: React.FC = () => {
  const ctx = useContext(AppContext);
  const [copied, setCopied] = React.useState(false);

  const copyToClipboard = () => {
    if (ctx?.state.generatedCode) {
      navigator.clipboard.writeText(ctx.state.generatedCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold">Production Code</h2>
          <p className="text-slate-400 text-sm">Standalone HTML with integrated Tailwind CSS.</p>
        </div>
        <div className="flex items-center gap-3">
          <button 
            onClick={copyToClipboard}
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-slate-900 hover:bg-slate-800 border border-slate-700 text-sm font-semibold transition-all"
          >
            {copied ? <Check size={16} className="text-emerald-500" /> : <Copy size={16} />}
            {copied ? "Copied!" : "Copy Code"}
          </button>
          <button 
            onClick={() => ctx?.dispatch({ type: 'SET_STEP', payload: AppStep.PREVIEW })}
            className="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-sm font-bold transition-all shadow-lg shadow-indigo-600/30"
          >
            <Play size={16} fill="currentColor" />
            Live Preview
          </button>
        </div>
      </div>

      <div className="relative group">
        <div className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-fuchsia-500 rounded-3xl blur opacity-20 group-hover:opacity-30 transition-opacity" />
        <div className="relative bg-slate-950 rounded-3xl border border-slate-800 p-8 h-[600px] overflow-hidden flex flex-col shadow-2xl">
          <div className="flex items-center gap-2 mb-6 border-b border-slate-800 pb-4">
            <div className="w-3 h-3 rounded-full bg-slate-800" />
            <span className="text-xs font-mono text-slate-500">index.html</span>
          </div>
          <pre className="flex-1 overflow-auto custom-scrollbar font-mono text-sm leading-relaxed text-indigo-100">
            <code>{ctx?.state.generatedCode}</code>
          </pre>
        </div>
      </div>
    </div>
  );
};

export default CodeViewPage;
